<div class="row mb-3">
  <div class="col-md-2"></div>
  <div class="col-12 col-md-8">
    <input
      type="text"
      class="w-80 ml-4"
      name="filterVideo"
      [(ngModel)]="search"
      placeholder="search..."
      (ngModelChange)="filterVideos()">
    <button class="desktop-only"><i class="fa fa-search"></i></button>
  </div>
</div>

<div *ngIf="filteredVideos.length == 0; else videoCard" class="card topic-card">
  <div class="card-body">
    <h5 class="text-center">No videos found or posted yet!</h5>
  </div>
</div>

<ng-template #videoCard>
<div class="row">
  <ng-container *ngFor="let vid of filteredVideos">
    <div *ngIf="vid.posted == true" class="col-12 col-md-6 mb-3">
      <iframe width="100%" height="300" src="https://www.youtube.com/embed/1ozGKlOzEVc" frameborder="0" allowfullscreen></iframe>
      <div class="row">
        <div class="col-4"><b>Title:</b></div>
        <div class="col-8">{{ vid.title }}</div>
        <div class="col-4"><b>Description:</b></div>
        <div class="col-8">{{ vid.description }}</div>
        <div class="col-4"><b>Date:</b></div>
        <div class="col-8">{{ vid.date | date}}</div>
      </div>
    </div>
  </ng-container>
</div>
</ng-template>
